import axios from "axios";

const USER_PROFILE_URL = process.env.REACT_APP_API_USER_PROFILE_URL;
const getToken = (token) => ({Authorization: `Bearer ${token}`});

// 프로필 조회
export const getProfile = (token) => {
    return axios.get(`${USER_PROFILE_URL}`, {
        headers: getToken(token),
    });
};

// 프로필 수정
export const updateProfile = (token, data) => {
    return axios.put(`${USER_PROFILE_URL}`, data, {
        headers: getToken(token),
    });
};

// 프로필사진 수정
export const updateProfileImage = (token, data) => {
    return axios.post(`${USER_PROFILE_URL}/image`, data, {
        headers: getToken(token),
    });
};

// 프로필사진 삭제
export const deleteProfileImage = (token) => {
    return axios.delete(`${USER_PROFILE_URL}/image`, {
        headers: getToken(token),
    });
};

// 비밀번호 확인
export const getPasswordForCheck = (token, data) => {
    return axios.post(`${USER_PROFILE_URL}/passwd`, data, {
        headers: getToken(token),
    });
};

// 비밀번호 변경
export const updatePassword = (token, data) => {
    return axios.put(`${USER_PROFILE_URL}/passwd`, data, {
        headers: getToken(token),
    });
};
